<div class="layout">
  <div class="header">
    <h3>Please fill in your account details.</h3>
  </div>
  <form [formGroup]="tenantInfoForm" class="form">
    <mat-form-field class="field input">
      <mat-label>First Name</mat-label>
      <input matInput id="firstName" formControlName="firstName" name="firstName" required>
      @if (tenantInfoForm.get('firstName')?.invalid) {
      <mat-error>{{errorMessage(tenantInfoForm.get('firstName'))}}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="field input">
      <mat-label>Last Name</mat-label>
      <input matInput id="lastName" formControlName="lastName" name="lastName" required>
      @if (tenantInfoForm.get('lastName')?.invalid) {
      <mat-error>{{errorMessage(tenantInfoForm.get('lastName'))}}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="field input">
      <mat-label>Email Address</mat-label>
      <input matInput id="emailAddress" formControlName="emailAddress" name="emailAddress" email="true" required>
      @if (tenantInfoForm.get('emailAddress')?.invalid) {
      <mat-error>{{errorMessage(tenantInfoForm.get('emailAddress'))}}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="field input">
      <mat-label>Company Name</mat-label>
      <input matInput id="companyName" formControlName="companyName" name="companyName" required>
      @if (tenantInfoForm.get('companyName')?.invalid) {
      <mat-error>{{errorMessage(tenantInfoForm.get('companyName'))}}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="field input">
      <mat-label>Company Tenant Name</mat-label>
      <input matInput id="tenantName" formControlName="tenantName" name="tenantName" required>
      <button
        mat-icon-button
        matSuffix
        type="button"
        class="field-help"
        aria-label="Tenant name help"
        matTooltip="This name is auto-generated for convenience. Can be replaced, but save this name for logging in later.

Acceptable characters: a-z, 0-9, -."
        matTooltipClass="tenant-name-tooltip"
        matTooltipPosition="right">
        <mat-icon>info</mat-icon>
      </button>
      @if (tenantInfoForm.get('tenantName')?.invalid) {
      <mat-error>{{errorMessage(tenantInfoForm.get('tenantName'))}}</mat-error>
      }
    </mat-form-field>
    <mat-form-field class="field input">
      <mat-label>Username</mat-label>
      <input matInput id="username" formControlName="username" name="username" required>
      @if (tenantInfoForm.get('username')?.invalid) {
      <mat-error>{{errorMessage(tenantInfoForm.get('username'))}}</mat-error>
      }
    </mat-form-field>
    <div class="form-actions">
      <button mat-button class="secondary-action" type="button">Cancel</button>
      @if (!finalForm) {
      <button mat-raised-button color="primary" class="primary-action" (click)="doChangeStep('forward')"
        [disabled]="tenantInfoForm.invalid" type="submit">
        Next
      </button>
      } @else {
      <button mat-raised-button color="primary" class="primary-action" (click)="doSubmitForm()"
        [disabled]="tenantInfoForm.invalid || status.loading" type="submit">
        @if (!status.loading) {
        <span>Submit</span>
        } @else {
        <mat-spinner [diameter]="25"></mat-spinner>
        }
      </button>
      }
    </div>
  </form>
</div>
